export class ProductModel {
  views?: number;
  favorite?: boolean;
  set?: boolean;
  id: string;
  model: string;
  type: string;
  material: string;
  color: string;
  price: string;
  description_dealer: {
    FR: string;
    EN: string;
    DE: string;
    NL: string;
  };
  dealer_ser_no: number;
  dealer_name: string;
  dealer_address: string;
  dealer_city: string;
  dealer_country: string;
  dealer_phone: string;
  dealer_email: string;
  dealer_website: string;
  dealer_distance: string;
  images: {
    cropped: string;
    original: string;
  }[];
  model_info: {};
  article_set: {
    Amount: string;
    ArticleNumber: string;
    Color: string;
    Material: string;
    OrderlineId: string;
    Type: string;
  }[];
}

export class FiltersModel {
  Color: {
    name: string;
    options: { value: string; description: string; available: boolean; }[];
    selected: string;
    type: string;
  };
  Dealer: {
    name: string;
    options: { value: string; description: string; available: boolean; }[];
    selected: string;
    type: string;
  };
  Keyword: {
    name: string;
    value: string;
    type: string;
  };
  Material: {
    name: string;
    options: { value: string; description: string; available: boolean; }[];
    selected: string;
    type: string;
  };
  Model: {
    name: string;
    options: { value: string; description: string; available: boolean; }[];
    selected: string;
    type: string;
  };
  PriceRange: {
    name: string;
    options: { value: string; description: string; available: boolean; }[];
    selected: string;
    type: string;
  };
  Radius: {
    Country: {
      type: string;
      name: string;
      selected: string;
      options: { value: string; description: string; }[];
    };
    Distance: {
      type: string;
      name: string;
      value: string;
    };
    Zip: {
      type: string;
      name: string;
      value: string;
    };
    type: string;
  };
  Type: {
    name: string;
    options: { value: string; description: string; available: boolean; }[];
    selected: string;
    type: string;
  };
  Sorting: {
    name: string;
    type: string;
    options: { value: string; description: string; }[];
    selected: string;
  };
}

export class FilterSidebarModel {
  Color: { opened: boolean; showall: boolean; } = {
    opened: true,
    showall: false
  };
  Dealer: { opened: boolean; showall: boolean; } = {
    opened: false,
    showall: false
  };
  Material: { opened: boolean; showall: boolean; } = {
    opened: false,
    showall: false
  };
  Model: { opened: boolean; showall: boolean; } = {
    opened: true,
    showall: false
  };
  Pricerange: { opened: boolean; showall: boolean; } = {
    opened: false,
    showall: false
  };
  Type: { opened: boolean; showall: boolean; } = {
    opened: true,
    showall: false
  };
  Radius: { opened: boolean; } = {
    opened: true
  };
  Country: { opened: boolean; } = {
    opened: false
  };
}

export class PaginationModel {
  page: number;
  pages: { value: number }[];
  results_per_page: number;
  total_hits: number;
  total_pages: number;
}

export class SlideshowModel {
  slides: [
    { image: { small: string; large: string; } }
  ];
}

export class DealerMessageModel {
  type: string = 'contact_dealer';
  email_dealer: string = '';
  name: string = '';
  phone: string = '';
  email_customer: string = '';
  product: string = '';
  text: string = '';
  product_id: string = '';
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/components/shop/shop.model.ts